const FOCUSABLE_ELEMENTS = ["a[href]", "area[href]", "input:not([disabled]):not([hidden])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "iframe", "object", "embed", "[tabindex]:not([tabindex='-1'])"].join(",");

/**
 * Gets keyboard-focusable elements within the Menu. This only looks for
 * buttons and anchors. Other elements aren't supported in the menu.
 *
 * See https://stackoverflow.com/questions/7668525/is-there-a-jquery-selector-to-get-all-elements-that-can-get-focus
 */
export function getKeyboardFocusableElementsIn(element) {
  return Array.from(element.querySelectorAll(FOCUSABLE_ELEMENTS));
}
export function isFocusableElement(element) {
  return element.matches(FOCUSABLE_ELEMENTS);
}

/**
 * Checks the element and its ancestors, up until @param within exclusive, to see if the element or
 * any of those ancestors are focusable.
 */
export function isWithinFocusableElement(element, withinElement) {
  let currentElement = element;
  while (currentElement && currentElement !== withinElement && currentElement !== document.body) {
    if (isFocusableElement(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
//# sourceMappingURL=focusUtil.js.map